import React, { useEffect, useState, useRef } from "react";
import ActivityDetector from "react-activity-detector";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import {
  getCookies,
  getUserInfo,
  removeCookies,
  setLockScreen,
} from "../../utils/configuration";
// import { refreshToken } from "../../api/api-config-interceptors";

const DialogWarningExpired = () => {
  const interVal = useRef<NodeJS.Timeout | number>(0);
  const interValCheckExpired = useRef<NodeJS.Timeout | number>(0);
  const [countDown, setCountDown] = useState(20);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (countDown && visible) {
      interVal.current = setInterval(() => {
        setCountDown((prev) => prev - 1);
      }, 1000);
    }
    if (countDown === 0) {
      clearInterval(interVal.current as NodeJS.Timeout);
    }
    return () => clearInterval(interVal.current as NodeJS.Timeout);
  }, [countDown, visible]);

  useEffect(() => {
    interValCheckExpired.current = setInterval(() => {
      if (getUserInfo()) {
        if (getCookies("isShowDialog") === "true") {
          setVisible(true);
        }
        if (countDown === 0) {
          removeCookies("isShowDialog");
          setLockScreen(true);
          setVisible(false);
          setCountDown(20);
        }
      }
    }, 1000);
    return () => clearInterval(interValCheckExpired.current as NodeJS.Timeout);
  }, [countDown, visible]);

  const onCancelDialog = () => {
    // refreshToken();
    removeCookies("isShowDialog");
    setCountDown(20);
    setVisible(false);
  };

  const onActive = () => {
    removeCookies("isShowDialog");
  };

  return (
    <Dialog
      open={visible}
      onClose={() => { }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <ActivityDetector
        activityEvents={[
          "click",
          "mousemove",
          "keydown",
          "DOMMouseScroll",
          "mousewheel",
          "mousedown",
          "touchstart",
          "touchmove",
          "focus",
        ]}
        enabled={true}
        timeout={10 * 60 * 1000}
        onActive={onActive}
      />
      <DialogContent className="py-6">
        <DialogContentText className="text-center text-gray-800 text-base">
          Ứng dụng sẽ đăng xuất sau{" "}
          <span className="text-red-600 font-semibold">{countDown}</span> giây
        </DialogContentText>
      </DialogContent>
      <DialogActions className="border-t px-6 pt-4 pb-2">
        <Button
          onClick={onCancelDialog}
          variant="contained"
          className="!bg-blue-600 hover:!bg-blue-700 text-white px-4 py-2 rounded-md"
        >
          Huỷ
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogWarningExpired;
